import React from 'react';
import { Box, Typography } from '@mui/material';
import GlassCard from '../../ui/glass/components/GlassCard';

/**
 * Ortak sayfa başlığı (Faz 8 UI primitifi).
 * De-facto desenden çıkarıldı (UrunSatisKayitlari): GlassCard + h5(primary) + alt açıklama,
 * sağda aksiyon alanı (arama/export/birincil buton). Tüm liste sayfalarında tutarlılık için.
 *
 * @param {string}      title     Başlık (zorunlu)
 * @param {string}      subtitle  Alt açıklama (opsiyonel)
 * @param {React.Node}  icon      Başlığın solunda ikon (opsiyonel)
 * @param {React.Node}  children  Sağ taraftaki aksiyonlar (arama, butonlar)
 * @param {object}      sx        Ek stil
 */
const PageHeader = ({ title, subtitle, icon, children, sx = {} }) => (
    <GlassCard hoverEffect={false} sx={{ mb: 2, p: 2, ...sx }}>
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: 2,
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
                {icon && (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: 44,
                            height: 44,
                            borderRadius: 2,
                            flexShrink: 0,
                            color: 'primary.main',
                            bgcolor: (theme) => theme.palette.mode === 'dark'
                                ? 'rgba(34,211,238,0.12)'
                                : 'rgba(8,145,178,0.08)',
                            '& svg': { fontSize: 26 },
                        }}
                    >
                        {icon}
                    </Box>
                )}
                <Box sx={{ minWidth: 0 }}>
                    <Typography variant="h5" sx={{ fontWeight: 600, color: 'primary.main' }} noWrap>
                        {title}
                    </Typography>
                    {subtitle && (
                        <Typography variant="body2" color="text.secondary">
                            {subtitle}
                        </Typography>
                    )}
                </Box>
            </Box>

            {children && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
                    {children}
                </Box>
            )}
        </Box>
    </GlassCard>
);

export default PageHeader;
